import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

// Store
import { actions } from 'core/store'

// Styled Elements
import { ModalBodyWrapper } from './RemoveUserModal.elements'

// Views
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'views/components'

// Hooks
import { useUpdateUser } from 'core/hooks/api'

// Map Redux Props
const mapStateToProps = (state) => state
const mapDispatchToProps = actions

function RemoveUserModal(props) {
  // Destructure
  const { ui, actions, auth } = props

  // Store State
  const { isRemoveUserModalOpen } = ui
  const { userToDeact } = auth

  // Store Actions
  const { toggleRemoveUserModal, setIsPageTableUpdated, setUserToDeact } = actions

  // Hooks
  const { updateUser, updateUserError, isUpdateUserLoading } = useUpdateUser()

  // Functions
  const toggleModal = () => {
    toggleRemoveUserModal()
  }
  const handleDeact = () => {
    updateUser({ user_id: userToDeact.user_id, is_active: userToDeact.is_active })
  }

  // UseEffect
  useEffect(() => {
    if (isRemoveUserModalOpen) {
      if (!isUpdateUserLoading && !updateUserError) {
        setIsPageTableUpdated(true)
        setUserToDeact()
        toggleRemoveUserModal()
      }
    }
  }, [isUpdateUserLoading])
  return (
    <Modal isOpen={isRemoveUserModalOpen} toggle={toggleModal}>
      <ModalHeader toggle={toggleModal}>Remove User</ModalHeader>
      <ModalBody>
        {isUpdateUserLoading && <ModalBodyWrapper>Removing User...</ModalBodyWrapper>}
        {!isUpdateUserLoading && !updateUserError && (
          <ModalBodyWrapper>Are you sure you want to remove this user?</ModalBodyWrapper>
        )}
        {!isUpdateUserLoading && updateUserError && (
          <ModalBodyWrapper>An error occurred in removing user, please try again later.</ModalBodyWrapper>
        )}
      </ModalBody>
      <ModalFooter>
        <Button fullWidth type="button" onClick={toggleModal} variant="outlined" disabled={isUpdateUserLoading}>
          Cancel
        </Button>
        <Button fullWidth type="button" onClick={handleDeact} color="secondary" disabled={isUpdateUserLoading}>
          Remove
        </Button>
      </ModalFooter>
    </Modal>
  )
}

// Default Props
RemoveUserModal.defaultProps = {
  ui: {},
  form: {},
  actions: {},
}

// Proptypes Validation
RemoveUserModal.propTypes = {
  ui: PropTypes.shape({ isRemoveUserModalOpen: PropTypes.bool }),
  form: PropTypes.shape({
    activityToRemove: PropTypes.shape({
      type: PropTypes.string,
      hash: PropTypes.string,
    }),
  }),
  auth: PropTypes.shape({
    userToDeact: PropTypes.shape({ user_id: PropTypes.string, is_active: PropTypes.bool }),
  }),
  actions: PropTypes.shape({
    toggleRemoveUserModal: PropTypes.func,
    setIsPageTableUpdated: PropTypes.func,
    setUserToDeact: PropTypes.func,
    setShowHeaderLoader: PropTypes.func,
  }),
}

export default connect(mapStateToProps, mapDispatchToProps)(RemoveUserModal)
